































import { Vue, Component } from 'vue-property-decorator'
import Table, { Config, Pagination } from '@/views/enroll/components/Table.vue'
import { notify, comfirm } from '@/utils/notification'
import { SpringExam } from '@/models/springexam/SpringExam'
import { getQueryedList, del } from '@/api/springexam/springexam'
import ExamCreater from './components/ExamCreater.vue'
import ExamDetail from './components/ExamDetail.vue'
import ExamEditor from './components/ExamEditor.vue'

@Component({
  components: { Table, ExamCreater, ExamDetail, ExamEditor }
})
export default class SpringExamManage extends Vue {
  InstantData: SpringExam[] = []
  InstantCount = 0
  selectedExam: SpringExam = {
    name: '',
    explain: '',
    examProjects: [],
    examUsers: []
  }
  loading = false
  showCreater = false
  showDetail = false
  showEditor = false
  get Instantpagination(): Pagination {
    return {
      current: 1,
      pagesize: 10
    }
  }
  get InstantConfig(): Config {
    return {
      rowKey: 'id',
      total: this.InstantCount,
      selection: 'radio',
      maxHeight: 700,
      columns: [
        // { prop: 'id', label: 'ID', width: 80 },
        { prop: 'name', label: '考试名称', width: 200, fixed: 'left' },
        {
          prop: 'explain',
          label: '说明'
        },
        {
          prop: 'avaliable',
          label: '是否当前考试',
          width: 100,
          formatter: this.formateSwitch
        },
        {
          prop: 'option',
          label: '操作',
          type: {
            type: 'buttonGroup',
            group: [
              {
                event: 'Edit',
                text: '编辑',
                right: '',
                buttonType: 'primary'
              },
              {
                event: 'Details',
                text: '详细',
                right: '',
                buttonType: 'primary'
              },
              {
                event: 'Delete',
                text: '删除',
                right: '',
                buttonType: 'danger'
              }
            ],
            style: 'group',
            size: 'small'
          },
          width: 200,
          fixed: 'right'
        }
      ]
    }
  }

  createExam() {
    this.showCreater = true
  }

  created() {
    this.loadData(this.Instantpagination)
  }

  formateSwitch(celValue: boolean) {
    if (celValue) {
      return '<strong style="color:green">是</strong>'
    } else return '<div style="color:red">否</div>'
  }

  backToTable() {
    this.showCreater = false
  }

  backDetailToTable() {
    this.showDetail = false
  }

  backEditorToTable() {
    this.showEditor = false
  }

  saveSuccess() {
    this.showCreater = false
    this.loadData(this.Instantpagination)
  }

  editSuccess() {
    this.showEditor = false
    this.loadData(this.Instantpagination)
  }

  async loadData(pagination: Pagination) {
    try {
      this.loading = true
      let limit = pagination.pagesize
      let offset = pagination.pagesize * (pagination.current - 1)
      const { rows, total } = await getQueryedList(limit, offset)
      this.InstantCount = total
      this.InstantData = rows
    } catch (e) {
      notify('获取数据失败', e)
    }
    this.loading = false
    return this.InstantData
  }

  async onButtonClick($event: any) {
    switch ($event.event) {
      case 'Edit': {
        this.showEditor = true
        this.selectedExam = $event.row
        return
      }
      case 'Details': {
        this.selectedExam = $event.row
        this.showDetail = true
        return
      }

      case 'Delete': {
        this.selectedExam = $event.row
        await comfirm(`确认删除${$event.row.name}么?`, { type: 'warning' })
        try {
          await del(this.selectedExam.id as string)
          notify('删除成功！')
          this.loadData(this.Instantpagination)
        } catch (e) {
          notify('删除失败！', e)
        }
        return
      }
      default:
        break
    }
  }
}
